module.exports = __webpack_public_path__ + "img/icon_project.27034aa7.svg";